import { _ } from '@biesbjerg/ngx-translate-extract/dist/utils/utils';
export const ALL_HOTELCHAINS =
	[
		{
			"lowerName": "",
			"key": "",
			"value": _('ngOption.SelectHotelChain'),
			"chainCode": "",
			"chainName": ""
		},
		{
			"lowerName": "ameri suites club",
			"key": "Hotel",
			"value": "Ameri Suites Club",
			"chainCode": "ASC",
			"chainName": "Ameri Suites"
		},
		{
			"lowerName": "best western gold crown club intl",
			"key": "Hotel",
			"value": "Best Western Gold Crown Club Intl",
			"chainCode": "BW",
			"chainName": "Best Western"
		},
		{
			"lowerName": "Boutique hotels",
			"key": "Hotel",
			"value": "Boutique Hotels",
			"chainCode": "BOUH",
			"chainName": "Boutique Hotels"
		},
		{
			"lowerName": "canadian pacific club",
			"key": "Hotel",
			"value": "Canadian Pacific Club",
			"chainName": "Canadian Pacific",
			"chainCode": "12"
		},
		{
			"lowerName": "choice privileges",
			"key": "Hotel",
			"value": "Choice Privileges",
			"chainCode": "UB",
			"chainName": "Choice Hotels"
		},
		{
			"lowerName": "club carlson",
			"key": "Hotel",
			"value": "Club Carlson",
			"chainCode": "CW",
			"chainName": "Carlson Hospitality Group"
		},
		{
			"lowerName": "club ramada",
			"key": "Hotel",
			"value": "Club Ramada",
			"chainCode": "CRA",
			"chainName": "Ramada Hotels"
		},
		{
			"lowerName": "delta privilege",
			"key": "Hotel",
			"value": "Delta Privilege",
			"chainCode": "16",
			"chainName": "Delta"
		},
		{
			"lowerName": "exclusive card (sofitel)",
			"key": "Hotel",
			"value": "Exclusive Card (SOFITEL)",
			"chainCode": "26",
			"chainName": "Sofitel Hotels"
		},
		{
			"lowerName": "fairmont presidents club",
			"key": "Hotel",
			"value": "Fairmont Presidents Club",
			"chainCode": "17",
			"chainName": "Fairmont"
		},
		{
			"lowerName": "fiesta americana fiesta rewards",
			"key": "Hotel",
			"value": "Fiesta Americana Fiesta Rewards",
			"chainCode": "20",
			"chainName": "Fiesta Americana"
		},
		{
			"lowerName": "frequent traveler plan (helmsley)",
			"key": "Hotel",
			"value": "Frequent Traveler Plan (Helmsley)",
			"chainCode": "22",
			"chainName": "Helmsley"
		},
		{
			"lowerName": "golden circle club (shangri la)",
			"key": "Hotel",
			"value": "Golden Circle Club (Shangri La)",
			"chainCode": "GCC",
			"chainName": "Shangri La"
		},
		{
			"lowerName": "gold mark (adams mark)",
			"key": "Hotel",
			"value": "Gold Mark (Adams Mark)",
			"chainCode": "1",
			"chainName": "Adams Mark"
		},
		{
			"lowerName": "guest rewards (westmark)",
			"key": "Hotel",
			"value": "Guest Rewards (Westmark)",
			"chainCode": "33",
			"chainName": "Westmark"
		},
		{
			"lowerName": "heritage rewards",
			"key": "Hotel",
			"value": "Heritage Rewards",
			"chainCode": "HR",
			"chainName": "Heritage Hotels"
		},
		{
			"lowerName": "hilton hhonors",
			"key": "Hotel",
			"value": "Hilton HHonors",
			"chainCode": "HL",
			"chainName": "Hilton Hotels"
		},
		{
			"lowerName": "hyatt gold passport",
			"key": "Hotel",
			"value": "Hyatt Gold Passport",
			"chainCode": "HY",
			"chainName": "Hyatt Group"
		},
		{
			"lowerName": "la invitation/ carte noire (le meridien)",
			"key": "Hotel",
			"value": "La Invitation/ Carte Noire (Le Meridien)",
			"chainCode": "19",
			"chainName": "Le Meridien"
		},

		{
			"lowerName": "omni select guest program",
			"key": "Hotel",
			"value": "Omni Select Guest Program",
			"chainCode": "ON",
			"chainName": "Omni"
		},
		{
			"lowerName": "priority club worldwide (holiday inn)",
			"key": "Hotel",
			"value": "Priority Club Worldwide (Holiday Inn)",
			"chainCode": "HOLCC",
			"chainName": "Holiday Inn"
		},
		{
			"lowerName": "redi card (red roof)",
			"key": "Hotel",
			"value": "Redi Card (Red Roof)",
			"chainCode": "REC",
			"chainName": "Red Roof"
		},
		{
			"lowerName": "returns club (la quinta)",
			"key": "Hotel",
			"value": "Returns Club (La Quinta)",
			"chainCode": "QC",
			"chainName": "La Quinta"
		},
		{
			"lowerName": "road runner club (budgetel)",
			"key": "Hotel",
			"value": "Road Runner Club (Budgetel)",
			"chainCode": "25",
			"chainName": "Budgetel"
		},
		{
			"lowerName": "select club (coast/westcoast)",
			"key": "Hotel",
			"value": "Select Club (Coast/Westcoast)",
			"chainCode": "14",
			"chainName": "Westcoast"
		},
		{
			"lowerName": "signature club",
			"key": "Hotel",
			"value": "Signature Club",
			"chainCode": "SC",
			"chainName": "Signature Hotels"
		},
		{
			"lowerName": "six continental club (intercontinental)",
			"key": "Hotel",
			"value": "Six Continental Club (Intercontinental)",
			"chainCode": "IC",
			"chainName": "Intercontinental Hotel Group"
		},
		{
			"lowerName": "marriott bonvoy",
			"key": "Hotel",
			"value": "Marriott Bonvoy",
			"chainCode": "SW",
			"chainName": "Marriott Hotels"
		},
		{
			"lowerName": "tai pan program (marco polo)",
			"key": "Hotel",
			"value": "Tai Pan Program (Marco Polo)",
			"chainCode": "TPP",
			"chainName": "Marco Polo"
		},
		{
			"lowerName": "the prestige program (concorde)",
			"key": "Hotel",
			"value": "The Prestige Program (Concorde)",
			"chainCode": "TPPC",
			"chainName": "Concorde"
		},
		{
			"lowerName": "travelodge guest rewards",
			"key": "Hotel",
			"value": "Travelodge Guest Rewards",
			"chainCode": "24",
			"chainName": "Travelodge"
		},
		{
			"lowerName": "v.i.p. club (super 8)",
			"key": "Hotel",
			"value": "V.I.P. Club (Super 8)",
			"chainName": "Super 8 Hotels",
			"chainCode": "VIP"
		},
		{
			"lowerName": "wellesley club (wellesley)",
			"key": "Hotel",
			"value": "Wellesley Club (Wellesley)",
			"chainCode": "34",
			"chainName": "Wellesley"
		},
		{
			"lowerName": "worldwide card (accor)",
			"key": "Hotel",
			"value": "Worldwide Card (ACCOR)",
			"chainCode": "ACC",
			"chainName": "Accor Hotels"
		},
		{
			"lowerName": "wyndham by request",
			"key": "Hotel",
			"value": "Wyndham By Request",
			"chainName": "Wyndham Hotel Group",
			"chainCode": "WY"
		}
	]
